/* eslint-disable @typescript-eslint/ban-ts-ignore */

import React, { useContext } from "react";

// @ts-ignore
import StackGrid from "react-stack-grid";

import { Loader } from "@culturehq/components";
import { Story } from "chq";
import ErrorBoundary from "components/common/ErrorBoundary";
import StoryThumbnailSelect from "components/common/StoryThumbnailSelect";
import LastIntersectedElement from "components/admin/settings/LastIntersectedElement";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";

interface StoriesGridProps {
  onSelectStory: (story: Story) => Promise<void>;
  onUnselectStory: (story: Story) => Promise<void>;
  rootRef: React.RefObject<HTMLDivElement>;
  selectedStories: Story[];
}

const StoriesGrid: React.FC<StoriesGridProps> = ({
  onSelectStory,
  onUnselectStory,
  rootRef,
  selectedStories
}) => {
  const {
    appending,
    columnWidth,
    handleThumbnailClick,
    isAppendEnable,
    onAppendStart,
    stories
  } = useContext(StoryModalContext);

  return (
    <StackGrid
      columnWidth={columnWidth}
      className="Story-Stack"
      monitorImagesLoaded
    >
      {stories?.map((story, index) => (
        <ErrorBoundary key={`${story.id}-${index}`}>
          <StoryThumbnailSelect
            index={index}
            key={`${story.id}-${index}`}
            story={story}
            onClick={handleThumbnailClick}
            selectedStories={selectedStories}
            selectStory={onSelectStory}
            unselectStory={onUnselectStory}
          />
        </ErrorBoundary>
      ))}
      {isAppendEnable && (
        <LastIntersectedElement
          rootRef={rootRef}
          onNearScreen={onAppendStart}
        />
      )}
      {appending && (<Loader loading />)}
    </StackGrid>
  );
};

export default StoriesGrid;
